import React from "react";

function Drag({onClick}) {
  return (
    <svg
      width="16"
      height="10"
      viewBox="0 0 16 10"
      fill="none"
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 10H12V6H16V10ZM10 10H6V6H10V10ZM4 10H0V6H4V10ZM16 4H12V0H16V4ZM10 4H6V0H10V4ZM4 4H0V0H4V4Z"
        fill="white"
      />
    </svg>
  );
}

export default Drag;
